// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-container[data-v-3e807dc8]{height:100%;width:100%}.embedtool[data-v-3e807dc8]{height:0;max-width:100%;overflow:hidden;padding-top:56%;position:relative}.embedtool embed[data-v-3e807dc8],.embedtool iframe[data-v-3e807dc8],.embedtool object[data-v-3e807dc8]{border:none;height:100%;left:0;position:absolute;top:0;width:100%}.embedtool .fluid-vids[data-v-3e807dc8]{position:static!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
